import React from 'react';
import {connect} from 'react-redux';
import {filterObjectByParams, sortArrayOfObjects} from 'helpers/common-helper';
import {PlayersListComponent as BasePlayersListComponent} from 'components/organisms/used-players-list/components/desktop/players-list/sports/nfl/classic';
import {
    combinePlayersOnDoublePosition,
    getPlayerLineupsQuantityPropName,
} from 'components/organisms/used-players-list/helpers';
import {isOverallFilterPosition} from 'components/organisms/filter-by-position/filter-position-interface';

class PlayersListComponent extends BasePlayersListComponent {
    getPlayers() {
        const {filters} = this.props;
        const filteredPlayers = this.getFilteredUsedPlayers();

        let searchParams = {
            ...this.getSearchRuleByPosition(),
        };

        if (filters.position.isKeyFlex() && !filters.isShowUnexposedPlayersEnabled()) {
            searchParams = {
                ...searchParams,
                ...this.getSearchRuleByFlexPosition(),
            };
        }

        let players = filterObjectByParams(filteredPlayers, searchParams, true);
        if (isOverallFilterPosition(filters.position)) {
            players = combinePlayersOnDoublePosition(players, ['QB', 'RB', 'WR', 'TE', 'D', 'K']);
        } else if (filters.position.isKeyFlex()) {
            players = combinePlayersOnDoublePosition(players, filters.position.getPositionNames());
        }

        const sortBy = getPlayerLineupsQuantityPropName(filters.position);

        return sortArrayOfObjects(players, sortBy, 'desc');
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        usedPlayers,
        filterLineupsByPlayer,
        lineupsData: {lineups},
        playersData: {games},
    } = state;

    return {
        sportConfig,
        usedPlayers: usedPlayers.players,
        filters: usedPlayers.filters,
        filterLineupsByPlayer,
        lineups,
        games,
    };
}

const PlayersList = connect(mapStatesToProps)(PlayersListComponent);

export {PlayersList};
